import React from 'react';

import ProfileSettingsPage from '@/features/profile/pages/profile-settings.page';

const ProfileSettingsRoute = () => {
  return <ProfileSettingsPage />;
};

export default ProfileSettingsRoute;
